import React from 'react';

const BeautyClinicsPage = () => {
  return (
    <div>
      <h1>Beauty Clinics</h1>
    </div>
  );
};

export default BeautyClinicsPage;
